import { tns } from 'tiny-slider/src/tiny-slider';

class TestimonialsSlider {
	constructor(el, prevButton, nextButton) {
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;

		const testimonialsSlider = tns({
			container: this.el,
			items: 1,
			slideBy: 1,
			mode: "gallery",
			autoplay: true,
			autoplayButtonOutput: false,
			speed: 400,
			controls: true,
			prevButton: this.prevButton,
			nextButton: this.nextButton
		});

		return testimonialsSlider;
		
	}
}

export default TestimonialsSlider;